export class FiltroDevolucion {
    FECHA_DESDE: Date;
    FECHA_HASTA: Date;
    ID_SOLICITANTE: number;

  constructor() { }
}
